import React from "react";
import ReactDOM from "react-dom";

import { ConfigProvider, GlobalSearchBox, tConfig } from "react-hawksearch";
import "react-hawksearch/dist/esm/react-hawksearch.css";
import { parseApiUrl, getDashboardUrl } from "../util/helper";

window.addEventListener("load", () => {
    var components = document.querySelectorAll(
        '[data-component="react-search-box-bootstrap"]'
    );

    if (components) {
        components.forEach((component) => {
            var dashboardUrl = getDashboardUrl(
                component.getAttribute("data-hawksearch-base-api")
            );
            var apiUrlObj = parseApiUrl({
                searchApi: component.getAttribute("data-hawksearch-search-api"),
                autocompleteApi: component.getAttribute(
                    "data-hawksearch-autocomplete-api"
                ),
            });

            const hawkConfig = {
                clientGuid: component.getAttribute("data-client-guid"),
                dashboardUrl: dashboardUrl,
                searchPageUrl: component.getAttribute("data-search-page"),
                indexName: component.getAttribute("data-index-name"),
                trackEventUrl: component.getAttribute('data-hawksearch-tracking-api'),
                ...apiUrlObj,
            };

            var trackingEvents = component.getAttribute('data-tracking-events');

            if (trackingEvents) {
                try {
                    hawkConfig.trackConfig = JSON.parse(trackingEvents.replaceAll("&quot;", '"'));
                }
                catch (e) {
                    console.error(e);
                    console.error("Wrong Track event configuration");
                }
            }

            // for auditorsearch setup autosuggest
            const isAuditorSearch = component.getAttribute("data-autosuggest");

            // apply translations if available
            var translationsEl = document.querySelectorAll(
                '[data-translations="react-translations"]'
            );

            if (translationsEl && translationsEl.length) {
                var translations = JSON.parse(translationsEl[0].innerHTML);

                tConfig.addResourceBundle(
                    "custom",
                    "translation",
                    translations,
                    true,
                    true
                );
                tConfig.changeLanguage("custom");
            }

            function SearcBox() {
                return (
                    <ConfigProvider config={hawkConfig}>
                        <GlobalSearchBox isAuditorSearch={!!isAuditorSearch} />
                    </ConfigProvider>
                );
            }

            ReactDOM.render(<SearcBox />, component);
        });
    }
});
